import React from 'react'

export const GoogleDocsContext = React.createContext({})
